/* global axios */

import ApiClient from './ApiClient';

class AiRoutingConfig extends ApiClient {
  constructor() {
    super('ai_routing_config', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.put(this.url, data);
  }
}

export default new AiRoutingConfig();